/* eslint-disable @angular-eslint/directive-selector */

import { Directive } from '@angular/core';

@Directive({
    selector: 'lui-label',
    standalone: false
})
export class LabelDirective {}
